/**
 * Paradise V2 destination collections (deploy / registry keys).
 * contractKind comes from ../config/v2DestinationContractKinds.json (keep IDs aligned).
 */
export const V2_DESTINATION_COLLECTIONS = [
  { id: 'paradise-pass-v2', name: 'Paradise Pass' },
  { id: 'paradise-furniture-v2', name: 'Paradise Furniture' },
  { id: 'paradise-pets-v2', name: 'Paradise Pets' },
  { id: 'paradise-genesis-collection-v2', name: 'Paradise Tycoon Genesis Collection' },
  { id: 'paradise-keys-v2', name: 'Paradise Keys' },
  { id: 'paradise-items-v2', name: 'Paradise Tycoon Tools' },
  { id: 'paradise-genesis-islands-v2', name: 'Paradise Genesis Islands' },
];
